export const EVENT_TAB_VALUE = {
    ONGOING: "ONGOING",
    COMPLETED: "COMPLETED"
};